import { Component, OnInit } from '@angular/core';

import { ApContentService } from '@ap/content';
import { ModalContent } from '@ap/modal';

import { FeedbackModalOptions, FeedbackOptions } from '../feedback.model';

import content from './modal.content.json';
import { FeedbackModalService } from './modal.service';

/**
 * @module FeedbackModalModule
 * @ngdoc component
 * @name FeedbackModalComponent
 */
@Component({
    selector: 'mijn-feedback-feedback-modal',
    templateUrl: 'modal.component.html',
    standalone: false
})
export class FeedbackModalComponent extends ModalContent<FeedbackModalOptions> implements OnInit {
    public showForm = true;
    public moodTitle: string;
    public mood: string;
    public customThankyouMessage: string;

    public constructor(
        private readonly contentService: ApContentService,
        private readonly feedbackModalService: FeedbackModalService
    ) {
        super();
    }

    public ngOnInit(): void {
        this.contentService.addContentItems(content);
        if (this.modalOptions.options) {
            this.moodTitle = this.modalOptions.options.moodTitle;
            this.mood = this.modalOptions.options.mood;
            this.customThankyouMessage = this.modalOptions.options.customThankYouMessage;
        }
    }

    public onFeedback(feedback: FeedbackOptions): void {
        this.showForm = false;
        this.feedbackModalService.postFeedback(feedback, this.modalOptions.options).subscribe();
    }

    public onCancel(): void {
        this.cancel();
    }

    public onContact(): void {
        this.decline();
    }
}
